// frontend/src/App.tsx
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Link } from "react-router-dom";
import { HomePage } from "./pages/HomePage";
import { CollectionPage } from "./pages/CollectionPage";
import { SequenceManagementPage } from "./pages/SequenceManagementPage";
import { CsvUploadPage } from "./pages/CsvUploadPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { FirebaseAuthProvider as AuthProvider } from "./contexts/FirebaseAuthContext";
import { UsageProvider } from "./contexts/UsageContext";
import { UserProfile } from "./components/UserProfile";
import { AIPrepLogoIcon } from "./components/CustomIcons";
import { ReviewPage } from "./pages/ReviewPage";
import { ReviewResultsPage } from "./pages/ReviewResultsPage";
import { PaymentSuccess } from "./pages/PaymentSuccess";
import { PaymentCanceled } from "./pages/PaymentCanceled";
import { useAuthRedirectHandler } from "./hooks/useAuthRedirectHandler";
// SessionRestorer removed - Firebase handles session persistence
import { logConfig } from "./config/environment";
import "./styles/global.css";
import "./styles/components.css";
import "./styles/review.css";

// Inner component that uses router hooks
function AppRoutes() {
  // Handle auth redirects
  useAuthRedirectHandler();

  return (
    <div className="app-wrapper">
      {/* Global Header */}
      <header className="app-header">
        <div className="header-content">
          <div className="app-brand">
            <Link to="/" className="app-logo-link">
              <AIPrepLogoIcon size={28} color="white" className="home-icon" />
              <h1 className="app-title">AIPrep</h1>
            </Link>
            <UserProfile />
          </div>
        </div>
      </header>

      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/collections/:id" element={<CollectionPage />} />
          <Route path="/collections/:id/problem/:problemId" element={<CollectionPage />} />
          <Route path="/collections/:id/sequence" element={<SequenceManagementPage />} />
          <Route path="/upload/csv" element={<CsvUploadPage />} />
          <Route path="/reviews" element={<ReviewPage />} />
          <Route path="/reviews/results" element={<ReviewResultsPage />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/canceled" element={<PaymentCanceled />} />
          {/* Legacy redirects */}
          <Route path="/review" element={<Navigate to="/reviews" replace />} />
          <Route path="/review-results" element={<Navigate to="/reviews/results" replace />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  // Log configuration in development
  React.useEffect(() => {
    logConfig();
  }, []);

  return (
    <ErrorBoundary>
      <AuthProvider>
        <UsageProvider>
          <Router>
            <AppRoutes />
          </Router>
        </UsageProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
